// TODO remove using ts-ignore

// Code serialization code used from backend API client serializeQuery.ts
export const serializeQuery = (obj: object): any => {
  const parts: string[][] = [];

  addQueryParts('', obj, parts, { dontPrefixRootObjectProps: true });

  return partsToQueryObject(parts);
};

const addQueryParts = (
  prefix: string,
  obj: any,
  acc: string[][],
  opts: {
    dontPrefixRootObjectProps?: boolean;
  } = {},
): void => {
  if (!obj) return;
  if (prefix) prefix = prefix + '.';

  const isRoot = !prefix;

  const add = (key: string, val: any) => {
    if (val === undefined) return;
    const fullKey = `${prefix}${key}`;
    // console.log('add', prefix, key, fullKey);
    acc.push([fullKey, val]);
  };

  Object.entries(obj).forEach(([key, val]) => {
    if (val === undefined) return;
    if (Array.isArray(val)) {
      val.forEach((v) => {
        if (typeof v === 'object') {
          throw new Error('Only array of primitive values is supported');
        }
        add(key, v);
      });
    } else if (typeof val === 'object') {
      const pref = isRoot && opts.dontPrefixRootObjectProps ? '' : prefix + key;
      // const pref = `${prefix}${key}.`

      addQueryParts(pref, val, acc);
    } else {
      add(key, val);
    }
  });
};

function partsToQueryObject(arr: string[][]): { [key: string]: any } {
  return arr.reduce((acc: { [key: string]: any }, [key, value]) => {
    if (acc.hasOwnProperty(key)) {
      // If the key already exists and has an array value, push to it
      if (Array.isArray(acc[key])) {
        acc[key].push(value);
      } else {
        // If the key exists and is not an array, convert it to an array
        acc[key] = [acc[key], value];
      }
    } else {
      // Otherwise, just add the key-value pair
      acc[key] = value;
    }
    return acc;
  }, {});
}
